export default __webpack_public_path__ + "static/media/meatball.6bfd7697.svg";